import React from 'react';
import { CheckIcon } from 'lucide-react';
type VolumeCardProps = {
  label: string;
  title: string;
  points: string[];
  finalLine: string;
};
export function VolumeCard({
  label,
  title,
  points,
  finalLine
}: VolumeCardProps) {
  return <article className="overflow-hidden rounded-md border border-line bg-white" data-id="element-163" data-mp="1250oal7mtp5m">
      <div className="flex items-center gap-2 bg-navy px-3 py-2" data-id="element-164" data-mp="y4gp7c3i0bgu">
        <span className="flex h-4 w-4 shrink-0 items-center justify-center rounded-[3px] bg-check" aria-hidden data-id="element-165" data-mp="1utxtpnqqvrgy">
          <CheckIcon className="h-3 w-3 text-white" strokeWidth={4} data-id="element-166" data-mp="1pu1oxma83w0c" />
        </span>
        <h3 className="font-heading text-[13px] font-extrabold uppercase leading-tight text-white md:text-[15px]" data-id="element-167" data-mp="1l335idtxuhsv">
          {label} — {title}
        </h3>
      </div>
      <div className="px-3 py-2.5" data-id="element-168" data-mp="1h06up9an3pzh">
        <div className="space-y-1 text-[14px] leading-[1.35] text-ink md:text-[15px]" data-id="element-169" data-mp="2dkfg7akzhqtv">
          {points.map(p => <p key={p} data-id="element-170" data-mp="28sdyva8yl9wz">{p}</p>)}
        </div>
        <p className="mt-1.5 font-heading text-[12px] font-extrabold uppercase leading-tight text-brand md:text-[13px]" data-id="element-171" data-mp="37c0jomwfm3q8">
          {finalLine}
        </p>
      </div>
    </article>;
}